import './SpacerBlock.scoped.scss'

const SpacerBlock = ({block}) => {
  return <div></div>
}

export default SpacerBlock
